import CTAButton from "components/CTAButton";
import styled from "styled-components/macro";
import { MODAL_Z_INDEX } from "styles/constants";
import { mediaMin } from "styles/media";

export const ModalBody = styled.div`
  padding: 28px 0 32px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;

  ${mediaMin.xs`
    padding: 28px 0 40px;
  `}
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 8px;

  ${CTAButton} {
    padding: 12px 32px 16px;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  z-index: ${MODAL_Z_INDEX};
  inset: 0;
  background-color: ${({ theme }) => theme.modalOverlayBackground};
`;

export const ModalContent = styled.div`
  width: 100vw;
  position: absolute;
  left: 0;
  bottom: 0;
  background: ${({ theme }) => theme.modalContentBackground};
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 4px 25px 0 ${({ theme }) => theme.palette.black15};
  color: ${({ theme }) => theme.text};
  outline: none;

  ${mediaMin.xs`
    width: 506px;
    left: 50%;
    top: 50%;
    bottom: initial;
    transform: translate(-50%, -50%);
  `}
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 32px;
  right: 32px;
  color: ${({ theme }) => theme.closeButton};

  &:hover {
    color: ${({ theme }) => theme.closeButtonHover};
  }
`;

export const ModalHeader = styled.header`
  font-size: 22px;
  font-weight: 600;
  line-height: 1.5;
`;
